import '../../App.css';
import React, { useContext, useState, useEffect } from "react";
import { ApiContext } from "../../context/ApiContext";
import { Tab, Tabs, Form, Row, Col } from 'react-bootstrap';
import { FaTimes, FaPlus } from 'react-icons/fa';
import { TbTrash } from "react-icons/tb";
import { StyleContext } from '../../context/StyleContext';
import SelectPadrao from '../SelectPadrao';

function ModalEditarSwotServico({ currentPage }) {
    const { ServicosPorArea, ListaServicoPorArea, SwotServicoObter, setSwotServicoObter, setModalEditarDemanda, ListaSwotServicoItem, SwotServicoItemLista, setAddSwotServicoItem, AdicionarSwotServicoItem, EditarSwotServico, ExcluirSwotServicoItem, forcaServicoItem, setForcaServicoItem,
        fraquezaServicoItem, setFraquezaServicoItem,
        oportunidadeServicoItem, setOportunidadeServicoItem,
        ameacaServicoItem, setAmeacaServicoItem, Ciclos, setError, Permissao, ListaAreaSwotServico, AreaSwotServico } = useContext(ApiContext)
    const { btnVer, btnCriar, btnPesquisar } = useContext(StyleContext)
    const [areaKey, setAreaKey] = useState(SwotServicoObter?.area.key)
    const [cicloId, setCicloId] = useState(SwotServicoObter?.cicloDemanda.id)

    const handleChange = (event) => {
        if (SwotServicoItemLista.length > 0 && event.target.name === 'areaKey') {
            setError("Capacidades já foram adicionadas, não é permitido alterar a área.");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }
        setSwotServicoObter({ ...SwotServicoObter, [event.target.name]: event.target.value });
        if (event.target.name === 'areaKey') {
            setAreaKey(event.target.value)
        }

        const cicloSelecionado = event.target.selectedOptions[0].getAttribute('data-key');
        setCicloId(parseInt(cicloSelecionado));
    };
    const handleChangeForca = (event) => {
        const updatedSwotServicoItem = { ...forcaServicoItem, [event.target.name]: event.target.value, tipo: "0" };

        if (updatedSwotServicoItem.gravidade && updatedSwotServicoItem.urgencia && updatedSwotServicoItem.tendencia) {
            const gut = updatedSwotServicoItem.gravidade * updatedSwotServicoItem.urgencia * updatedSwotServicoItem.tendencia;
            updatedSwotServicoItem.gut = gut;
        }

        setForcaServicoItem(updatedSwotServicoItem)
        setAddSwotServicoItem(updatedSwotServicoItem);
    };
    const handleChangeFraqueza = (event) => {
        const updatedSwotServicoItem = { ...fraquezaServicoItem, [event.target.name]: event.target.value, tipo: "1" };

        if (updatedSwotServicoItem.gravidade && updatedSwotServicoItem.urgencia && updatedSwotServicoItem.tendencia) {
            const gut = updatedSwotServicoItem.gravidade * updatedSwotServicoItem.urgencia * updatedSwotServicoItem.tendencia;
            updatedSwotServicoItem.gut = gut;
        }
        setFraquezaServicoItem(updatedSwotServicoItem)
        setAddSwotServicoItem(updatedSwotServicoItem);
    };
    const handleChangeOportunidade = (event) => {
        const updatedSwotServicoItem = { ...oportunidadeServicoItem, [event.target.name]: event.target.value, tipo: "2" };

        if (updatedSwotServicoItem.gravidade && updatedSwotServicoItem.urgencia && updatedSwotServicoItem.tendencia) {
            const gut = updatedSwotServicoItem.gravidade * updatedSwotServicoItem.urgencia * updatedSwotServicoItem.tendencia;
            updatedSwotServicoItem.gut = gut;
        }
        setOportunidadeServicoItem(updatedSwotServicoItem)
        setAddSwotServicoItem(updatedSwotServicoItem);
    };
    const handleChangeAmeaca = (event) => {
        const updatedSwotServicoItem = { ...ameacaServicoItem, [event.target.name]: event.target.value, tipo: "3" };

        if (updatedSwotServicoItem.gravidade && updatedSwotServicoItem.urgencia && updatedSwotServicoItem.tendencia) {
            const gut = updatedSwotServicoItem.gravidade * updatedSwotServicoItem.urgencia * updatedSwotServicoItem.tendencia;
            updatedSwotServicoItem.gut = gut;
        }
        setAmeacaServicoItem(updatedSwotServicoItem)
        setAddSwotServicoItem(updatedSwotServicoItem);
    };

    const fecharModal = () => {
        setSwotServicoObter({})
        setAddSwotServicoItem({})
        setModalEditarDemanda(false)
    }

    const chamarLista = async () => {
        ListaSwotServicoItem()
        ListaAreaSwotServico()
    }

    useEffect(() => {
        chamarLista()
    }, []);

    useEffect(() => {
        const cicloValido = SwotServicoObter.cicloDemandaId > 0;
        const areaValida = SwotServicoObter.area?.key?.length > 0;

        if (cicloValido && areaValida) {
            ListaServicoPorArea(SwotServicoObter.cicloDemandaId, SwotServicoObter.area.key);
        }
    }, [SwotServicoObter]);

    useEffect(() => {
        if (cicloId || areaKey) {
            ListaServicoPorArea(cicloId, areaKey);
        }
    }, [cicloId, areaKey])

    const opcoesServicos = ServicosPorArea && ServicosPorArea?.sort((a, b) => {
        return a.descricao.localeCompare(b.descricao);
    }).map(item => ({
        value: item.key,
        label: item.descricao,
        ativo: item.ativo
    })) || [];

    return (
        <div className="modal-criar-demanda">
            <div className="modal-criar-demanda-interno">
                <div className="header-modal-criar-demanda">
                    <div>
                        <h1 className="h1-modal">Editar SWOT de Serviço</h1>
                    </div>
                    <div className="btn-close-modal" onClick={() => fecharModal()}>
                        <FaTimes />
                    </div>
                </div>
                <form>
                    <div className="modal-content-criar-demanda">
                        <Tabs fill className='mt-3 mb-3'>
                            <Tab eventKey="info" title={<span>Informações</span>}>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Descrição</Form.Label>
                                            <Form.Control onChange={handleChange} maxLength={255} defaultValue={SwotServicoObter?.descricao} name="descricao" />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Área</Form.Label>
                                            <Form.Select aria-label="Default select example" value={areaKey} onChange={handleChange} name="areaKey">
                                                <option value={0}>Selecione</option>
                                                {AreaSwotServico && AreaSwotServico?.map((item) => {
                                                    return (
                                                        <option key={item.id} value={item.key} selected={item.key == SwotServicoObter?.area.key ? true : false}>
                                                            {item.descricao}
                                                        </option>
                                                    )
                                                })}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Ciclo</Form.Label>
                                        <Form.Select aria-label="Default select example" onChange={handleChange} name="cicloDemandaKey">
                                            <option value={0}>Selecione</option>
                                            {Ciclos && Ciclos?.map((item) => {
                                                return (
                                                    <option key={item.id} value={item.key} data-key={item.id} selected={item.key == SwotServicoObter?.cicloDemanda.key ? true : false}>
                                                        {item.descricao}
                                                    </option>
                                                )
                                            })}
                                        </Form.Select>
                                    </Form.Group>
                                </Row>
                            </Tab>
                            <Tab eventKey="forcas" title={<span>Forças</span>}>
                                <Row>
                                    <Col lg={5}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Serviço</Form.Label>
                                            <SelectPadrao
                                                name="servicoKey"
                                                options={opcoesServicos || []}
                                                value={forcaServicoItem?.servicoKey}
                                                onChange={handleChangeForca}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col lg={2}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Gravidade</Form.Label>
                                            <Form.Select value={forcaServicoItem?.gravidade} onChange={handleChangeForca} name="gravidade">
                                                <option value="">Selecione</option>
                                                <option value="1">Sem gravidade</option>
                                                <option value="2">Pouco grave</option>
                                                <option value="3">Grave</option>
                                                <option value="4">Muito grave</option>
                                                <option value="5">Extremamente grave</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col lg={2}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Urgência</Form.Label>
                                            <Form.Select value={forcaServicoItem?.urgencia} onChange={handleChangeForca} name="urgencia">
                                                <option value="">Selecione</option>
                                                <option value="1">Longuíssimo prazo</option>
                                                <option value="2">Longo prazo</option>
                                                <option value="3">Médio prazo</option>
                                                <option value="4">Curto</option>
                                                <option value="5">Imediatamente</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col lg={2}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Tendência</Form.Label>
                                            <Form.Select value={forcaServicoItem?.tendencia} onChange={handleChangeForca} name="tendencia">
                                                <option value="">Selecione</option>
                                                <option value="1">Desaparece</option>
                                                <option value="2">Reduz-se ligeiramente</option>
                                                <option value="3">Permanece</option>
                                                <option value="4">Aumenta</option>
                                                <option value="5">Piora muito</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col lg={1}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>GUT</Form.Label>
                                            <Form.Control
                                                readOnly
                                                placeholder='0'
                                                value={forcaServicoItem?.gut}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                    <button type="button" className="btn-dash btn-pesquisar" style={btnPesquisar} onClick={() => AdicionarSwotServicoItem()}><FaPlus style={{ marginRight: "5px" }} />Adicionar força</button>
                                </div>
                                Forças adicionadas
                                <div className="secao-comentario">
                                    {
                                        SwotServicoItemLista?.map((item, index) => {
                                            return (
                                                item.tipo === 0 &&
                                                <div key={index} className="content-comentario">
                                                    <div className='div-comentario'>
                                                        <p className="p-title">Forças:</p>
                                                        <p className="p-content" style={{ marginLeft: '5px' }}>{item.servico.descricao}</p>
                                                    </div>
                                                    <div className='div-comentario'>
                                                        <p className="p-content">{(item.gravidade)} | {item.urgencia} | {item.tendencia}</p>
                                                    </div>
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <p className="p-title">GUT: </p>
                                                        <p className="p-content" style={{ marginLeft: '5px' }}>{item.gut}</p>
                                                    </div>
                                                    <div className="div-button">
                                                        <button type="button" className="btn-del" onClick={() => ExcluirSwotServicoItem(item.key)}><TbTrash /></button>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                </div>
                            </Tab>
                            <Tab eventKey="fraquezas" title={<span>Fraquezas</span>}>
                                <Row>
                                    <Col lg={5}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Serviço</Form.Label>
                                            <SelectPadrao
                                                name="servicoKey"
                                                options={opcoesServicos || []}
                                                value={fraquezaServicoItem?.servicoKey}
                                                onChange={handleChangeFraqueza}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col lg={2}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Gravidade</Form.Label>
                                            <Form.Select value={fraquezaServicoItem?.gravidade} onChange={handleChangeFraqueza} name="gravidade">
                                                <option value={0}>Selecione</option>
                                                <option value={1}>Sem gravidade</option>
                                                <option value={2}>Pouco grave</option>
                                                <option value={3}>Grave</option>
                                                <option value={4}>Muito grave</option>
                                                <option value={5}>Extremamente grave</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col lg={2}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Urgência</Form.Label>
                                            <Form.Select value={fraquezaServicoItem?.urgencia} onChange={handleChangeFraqueza} name="urgencia">
                                                <option value={0}>Selecione</option>
                                                <option value={1}>Longuíssimo prazo</option>
                                                <option value={2}>Longo prazo</option>
                                                <option value={3}>Médio prazo</option>
                                                <option value={4}>Curto</option>
                                                <option value={5}>Imediatamente</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col lg={2}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Tendência</Form.Label>
                                            <Form.Select value={fraquezaServicoItem?.tendencia} onChange={handleChangeFraqueza} name="tendencia">
                                                <option value={0}>Selecione</option>
                                                <option value={1}>Desaparece</option>
                                                <option value={2}>Reduz-se ligeiramente</option>
                                                <option value={3}>Permanece</option>
                                                <option value={4}>Aumenta</option>
                                                <option value={5}>Piora muito</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col lg={1}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>GUT</Form.Label>
                                            <Form.Control
                                                readOnly
                                                value={fraquezaServicoItem?.gut}
                                                placeholder='0'
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                    <button type="button" className="btn-dash btn-pesquisar" style={btnPesquisar} onClick={() => AdicionarSwotServicoItem()}><FaPlus style={{ marginRight: "5px" }} />Adicionar fraqueza</button>
                                </div>
                                Fraquezas adicionadas
                                <div className="secao-comentario">
                                    {
                                        SwotServicoItemLista?.map((item, index) => {
                                            return (
                                                item.tipo === 1 &&
                                                <div key={index} className="content-comentario">
                                                    <div className='div-comentario'>
                                                        <p className="p-title">Fraquezas: </p>
                                                        <p className="p-content" style={{ marginLeft: '5px' }}>{item.servico.descricao}</p>
                                                    </div>
                                                    <div className='div-comentario'>
                                                        <p className="p-content">{(item.gravidade)} | {item.urgencia} | {item.tendencia}</p>
                                                    </div>
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <p className="p-title">GUT: </p>
                                                        <p className="p-content" style={{ marginLeft: '5px' }}>{item.gut}</p>
                                                    </div>
                                                    <div className="div-button">
                                                        <button type="button" className="btn-del" onClick={() => ExcluirSwotServicoItem(item.key)}><TbTrash /></button>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                </div>
                            </Tab>
                            <Tab eventKey="oportunidades" title={<span>Oportunidades</span>}>
                                <Row>
                                    <Col lg={5}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Serviço</Form.Label>
                                            <SelectPadrao
                                                name="servicoKey"
                                                options={opcoesServicos || []}
                                                value={oportunidadeServicoItem?.servicoKey}
                                                onChange={handleChangeOportunidade}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col lg={2}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Gravidade</Form.Label>
                                            <Form.Select value={oportunidadeServicoItem?.gravidade} onChange={handleChangeOportunidade} name="gravidade">
                                                <option value={0}>Selecione</option>
                                                <option value={1}>Sem gravidade</option>
                                                <option value={2}>Pouco grave</option>
                                                <option value={3}>Grave</option>
                                                <option value={4}>Muito grave</option>
                                                <option value={5}>Extremamente grave</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col lg={2}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Urgência</Form.Label>
                                            <Form.Select value={oportunidadeServicoItem?.urgencia} onChange={handleChangeOportunidade} name="urgencia">
                                                <option value={0}>Selecione</option>
                                                <option value={1}>Longuíssimo prazo</option>
                                                <option value={2}>Longo prazo</option>
                                                <option value={3}>Médio prazo</option>
                                                <option value={4}>Curto</option>
                                                <option value={5}>Imediatamente</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col lg={2}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Tendência</Form.Label>
                                            <Form.Select value={oportunidadeServicoItem?.tendencia} onChange={handleChangeOportunidade} name="tendencia">
                                                <option value={0}>Selecione</option>
                                                <option value={1}>Desaparece</option>
                                                <option value={2}>Reduz-se ligeiramente</option>
                                                <option value={3}>Permanece</option>
                                                <option value={4}>Aumenta</option>
                                                <option value={5}>Piora muito</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col lg={1}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>GUT</Form.Label>
                                            <Form.Control
                                                placeholder='0'
                                                readOnly
                                                value={oportunidadeServicoItem?.gut}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                    <button type="button" className="btn-dash btn-pesquisar" style={btnPesquisar} onClick={() => AdicionarSwotServicoItem()}><FaPlus style={{ marginRight: "5px" }} />Adicionar oportunidade</button>
                                </div>
                                Oportunidades adicionadas
                                <div className="secao-comentario">
                                    {
                                        SwotServicoItemLista?.map((item, index) => {
                                            return (
                                                item.tipo === 2 &&
                                                <div key={index} className="content-comentario">
                                                    <div className='div-comentario'>
                                                        <p className="p-title">Oportunidades: </p>
                                                        <p className="p-content" style={{ marginLeft: '5px' }}>{item.servico.descricao}</p>
                                                    </div>
                                                    <div className='div-comentario'>
                                                        <p className="p-content">{(item.gravidade)} | {item.urgencia} | {item.tendencia}</p>
                                                    </div>
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <p className="p-title">GUT: </p>
                                                        <p className="p-content" style={{ marginLeft: '5px' }}>{item.gut}</p>
                                                    </div>
                                                    <div className="div-button">
                                                        <button type="button" className="btn-del" onClick={() => ExcluirSwotServicoItem(item.key)}><TbTrash /></button>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                </div>
                            </Tab>
                            <Tab eventKey="ameacas" title={<span>Ameaças</span>}>
                                <Row>
                                    <Col lg={5}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Serviço</Form.Label>
                                            <SelectPadrao
                                                name="servicoKey"
                                                options={opcoesServicos || []}
                                                value={ameacaServicoItem?.servicoKey}
                                                onChange={handleChangeAmeaca}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col lg={2}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Gravidade</Form.Label>
                                            <Form.Select value={ameacaServicoItem?.gravidade} onChange={handleChangeAmeaca} name="gravidade">
                                                <option value={0}>Selecione</option>
                                                <option value={1}>Sem gravidade</option>
                                                <option value={2}>Pouco grave</option>
                                                <option value={3}>Grave</option>
                                                <option value={4}>Muito grave</option>
                                                <option value={5}>Extremamente grave</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col lg={2}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Urgência</Form.Label>
                                            <Form.Select value={ameacaServicoItem?.urgencia} onChange={handleChangeAmeaca} name="urgencia">
                                                <option value={0}>Selecione</option>
                                                <option value={1}>Longuíssimo prazo</option>
                                                <option value={2}>Longo prazo</option>
                                                <option value={3}>Médio prazo</option>
                                                <option value={4}>Curto</option>
                                                <option value={5}>Imediatamente</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col lg={2}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Tendência</Form.Label>
                                            <Form.Select value={ameacaServicoItem?.tendencia} onChange={handleChangeAmeaca} name="tendencia">
                                                <option value={0}>Selecione</option>
                                                <option value={1}>Desaparece</option>
                                                <option value={2}>Reduz-se ligeiramente</option>
                                                <option value={3}>Permanece</option>
                                                <option value={4}>Aumenta</option>
                                                <option value={5}>Piora muito</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col lg={1}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>GUT</Form.Label>
                                            <Form.Control
                                                readOnly
                                                value={ameacaServicoItem?.gut}
                                                placeholder='0'
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                    <button type="button" className="btn-dash btn-pesquisar" style={btnPesquisar} onClick={() => AdicionarSwotServicoItem()}><FaPlus style={{ marginRight: "5px" }} />Adicionar ameaça</button>
                                </div>
                                Ameaças adicionadas
                                <div className="secao-comentario">
                                    {
                                        SwotServicoItemLista?.map((item, index) => {
                                            return (
                                                item.tipo === 3 &&
                                                <div key={index} className="content-comentario">
                                                    <div className='div-comentario'>
                                                        <p className="p-title">Ameaças: </p>
                                                        <p className="p-content" style={{ marginLeft: '5px' }}>{item.servico.descricao}</p>
                                                    </div>
                                                    <div className='div-comentario'>
                                                        <p className="p-content">{(item.gravidade)} | {item.urgencia} | {item.tendencia}</p>
                                                    </div>
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <p className="p-title">GUT: </p>
                                                        <p className="p-content" style={{ marginLeft: '5px' }}>{item.gut}</p>
                                                    </div>
                                                    <div className="div-button">
                                                        <button type="button" className="btn-del" onClick={() => ExcluirSwotServicoItem(item.key)}><TbTrash /></button>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                </div>
                            </Tab>
                        </Tabs>
                    </div>
                    <div className="footer-modal-criar-demanda">
                        <button type="button" className="btn-dash btn-ver" style={btnVer} onClick={() => fecharModal()}>Cancelar</button>
                        {(!!Permissao.find(item => item.menu.descricao === "SWOT SERVICO" && item.edicao === true)) &&
                            <button type="button" className="btn-dash btn-criar" style={btnCriar} onClick={() => EditarSwotServico(currentPage)}>Salvar</button>
                        }
                    </div>
                </form>
            </div>
        </div>
    )
}

export default ModalEditarSwotServico